"use client";

import { TrendOddsDesktop } from "../OddsTrendBadge";
import { oddsBgNeutral, oddsBgUp, oddsBgDown } from "./oddsPopupStyles";

function trendToBgClass(trend) {
  const isUp = trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown = trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (isUp) return oddsBgUp;
  if (isDown) return oddsBgDown;
  return oddsBgNeutral;
}

export function PopupOddCell({ trend, children }) {
  const bg = trendToBgClass(trend);
  return (
    <p
      className={`relative m-0 mx-auto box-border h-[22px] w-full min-w-0 max-w-full rounded-[4px] px-1 text-center text-[12px] font-normal leading-[22px] text-[color:var(--theme-text)] sm:text-[13px] ${bg}`}
    >
      {children}
      <TrendOddsDesktop trend={trend} />
    </p>
  );
}
